import { TTheme } from '@/core/theme'
import { MenuIcon } from '@atbay/icons'
import { styled } from '@mui/system'

export const StyledMenuIcon = styled(MenuIcon)<{ theme?: TTheme }>`
    fill: ${({ theme }) => theme.colors.greys[400]};
    display: flex;
    align-items: center;
`
